import { useNavigate, useParams } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { usePerDiemPolicyQuery, useUpdatePerDiemPolicy } from "../api/queries";
import { PerDiemPolicyForm } from "../ui/PerDiemPolicyForm";

function roleFlags(kinds: string[] | null | undefined) {
  const set = new Set(kinds ?? ["dancer", "choreographer"]);
  return {
    roleDancer: set.has("dancer"),
    roleChoreographer: set.has("choreographer"),
    roleKol: set.has("kol"),
    roleMc: set.has("mc"),
    roleOther: set.has("other"),
  };
}

export function PerDiemPolicyEditPage() {
  const { id } = useParams({ from: "/app/performance/per-diem/$id/edit" });
  const nav = useNavigate({ from: "/app/performance/per-diem/$id/edit" });
  const { data: policy, isLoading } = usePerDiemPolicyQuery(id);
  const updatePolicy = useUpdatePerDiemPolicy(id);

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ເບ້ຍລ້ຽງຕ່າງແຂວງ", to: "/app/performance/per-diem" },
            { label: policy?.name ?? "..." },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h2 className="font-bold text-2xl tracking-tight">ແກ້ໄຂນະໂຍບາຍ</h2>
        </div>
        {isLoading ? (
          <p className="text-muted-foreground">ກຳລັງໂຫຼດ...</p>
        ) : !policy ? (
          <p className="text-destructive">ບໍ່ພົບນະໂຍບາຍ</p>
        ) : (
          <div className="rounded-xl border bg-card px-6">
            <PerDiemPolicyForm
              initialValues={{
                code: policy.code,
                name: policy.name,
                amountPerDay: policy.amountPerDay,
                amountPerEvent: policy.amountPerEvent,
                basis: policy.basis,
                status: policy.status,
                ...roleFlags(policy.appliesToRoleKinds),
              }}
              onSubmit={async (vals) => {
                try {
                  await updatePolicy.mutateAsync(vals);
                  nav({ to: "/app/performance/per-diem" });
                } catch {}
              }}
              onCancel={() => nav({ to: "/app/performance/per-diem" })}
              submitting={updatePolicy.isPending}
            />
          </div>
        )}
      </Main>
    </>
  );
}
